import { connect } from 'react-redux';
import Topbar from '../../modules/Topbar';
import {
  undoChanges,
  redoChanges,
  savePartsConfiguration,
  openAlertDialog,
  setSelectedCategory,
  setIsDataReady,
  getAccessoryVariantData,
  getAllAccessoryTypeDataOnTabClick
} from '../customizer.duck';
import {
  setIsLoading,
  setIsDashboardOpen,
  setIsConfigSaved
} from '../common.duck';

const mapStateToProps = state => ({
  siteUrl: state.customizer.siteUrl,
  userId: state.customizer.userId,
  showUndoStack: state.customizer.undoStack.length > 0,
  showRedoStack: state.customizer.redoStack.length > 0,
  customizer: state.customizer,
  selectedVariant: state.customizer.selectedVariant,
  isConfigSaved: state.common.isConfigSaved
});

const mapDispatchToProps = dispatch => ({
  undoChanges: () => {
    dispatch(undoChanges());
    dispatch(setIsConfigSaved(false));
  },
  redoChanges: () => {
    dispatch(redoChanges());
    dispatch(setIsConfigSaved(false));
  },
  setIsLoading: bool => {
    dispatch(setIsLoading(bool));
  },
  setIsDataReady: bool => {
    dispatch(setIsDataReady(bool));
  },
  openAlertDialog: alertInfo => {
    dispatch(openAlertDialog(alertInfo));
  },
  setIsDashboardOpen: () => {
    dispatch(setIsDashboardOpen(true));
  },
  onSaveChanges: () => {
    dispatch(setIsConfigSaved(true));
  },
  setSelectedCategory: category => {
    dispatch(setSelectedCategory(category));
  },
  savePartsConfiguration: customizer => {
    dispatch(savePartsConfiguration(customizer));
  },
  getAccessoryVariantData: variantId => {
    dispatch(getAccessoryVariantData(variantId));
  },
  getAllAccessoryTypeDataOnTabClick: accessoryVariant => {
    dispatch(getAllAccessoryTypeDataOnTabClick(accessoryVariant));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
